import type { Except } from '@festina-life/core'
import type { ReactNode } from 'react'

import type { FormikInputPropsForWrapper } from '../types'

export const getWrapperProps = <
  T extends Except<
    FormikInputPropsForWrapper,
    'label' | 'isTableCell' | 'existingValueConfig'
  > &
    Partial<
      Record<'defaultValue' | 'htmlFor' | 'error' | 'className', unknown>
    >,
>({
  isTableCell,
  existingValue,
  existingValueConfig: commonExistingValueConfig,
  label,
  inputValueDifferenceFromExistingValue,
  commonWrapperProps,
}: {
  isTableCell: FormikInputPropsForWrapper['isTableCell']
  commonWrapperProps: T
  label: FormikInputPropsForWrapper['label']
} & (
  | {
      existingValue: ReactNode
      existingValueConfig: FormikInputPropsForWrapper['existingValueConfig']
      inputValueDifferenceFromExistingValue: NonNullable<
        FormikInputPropsForWrapper['existingValueConfig']
      >['inputValueDifferenceFromExistingValue']
    }
  | {
      existingValue?: never
      existingValueConfig?: never
      inputValueDifferenceFromExistingValue?: never
    }
)) => {
  const existingValueConfig = {
    existingValue,
    inputValueDifferenceFromExistingValue,
    ...commonExistingValueConfig,
  } satisfies FormikInputPropsForWrapper['existingValueConfig']

  return isTableCell
    ? {
        ...commonWrapperProps,
        existingValueConfig,
        isTableCell: true as const,
      }
    : {
        ...commonWrapperProps,
        existingValueConfig,
        label: label as NonNullable<FormikInputPropsForWrapper['label']>,
        isTableCell: false as const,
      }
}
